import React from 'react';
import PropTypes from 'prop-types';
import { useDebounceForInput } from 'utils';
import { Input, IconButton, InputAdornment } from '@material-ui/core';
import cx from 'classnames';
import { GlobalSearch as SearchIcon, ClearIcon } from '../Icons';

const SearchField = ({
  value,
  onChange,
  classes,
  withDebounce,
  endIcon,
  withoutSearchIcon,
  disableUnderline,
  shouldResetDebounce,
  readOnly,
  noSpaceOnSide,
  ...props
}) => {
  const [searchValue, setSearchValue] = withDebounce
    ? useDebounceForInput({ func: onChange, wait: 450, initialValue: value, resetDebounce: shouldResetDebounce })
    : [value, onChange];
  const clearValue = () => setSearchValue('');
  const onChangeValue = (e) => setSearchValue(e.target.value);

  return (
    <Input
      readOnly={readOnly}
      value={searchValue}
      onChange={onChangeValue}
      fullWidth
      disableUnderline={disableUnderline}
      classes={{ underline: cx(classes.underline, noSpaceOnSide && classes.underlineBottom) }}
      startAdornment={
        <InputAdornment
          position="start"
          classes={{ root: cx(classes.searchIcon, noSpaceOnSide && classes.searchIconWithPadding) }}
          disablePointerEvents
        >
          {!withoutSearchIcon && <SearchIcon />}
        </InputAdornment>
      }
      endAdornment={
        <>
          {searchValue.length ? (
            <IconButton
              onClick={clearValue}
              classes={{ root: classes.clearButton }}
              data-testid="search-field-clear-value"
            >
              <ClearIcon />
            </IconButton>
          ) : null}
          {endIcon && <div className={classes.endIcon}>{endIcon}</div>}
        </>
      }
      data-testid="search-field-input"
      {...props}
    />
  );
};

SearchField.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  classes: PropTypes.objectOf(PropTypes.string),
  withDebounce: PropTypes.bool,
  endIcon: PropTypes.node,
  withoutSearchIcon: PropTypes.bool,
  disableUnderline: PropTypes.bool,
  shouldResetDebounce: PropTypes.bool,
  readOnly: PropTypes.bool,
  noSpaceOnSide: PropTypes.bool,
};

SearchField.defaultProps = {
  value: '',
  onChange: () => {},
  classes: {},
  withDebounce: false,
  endIcon: null,
  disableUnderline: false,
  shouldResetDebounce: false,
  noSpaceOnSide: false,
};

export default SearchField;
